import { ExportGapFilterType } from "@app/exports/enumerations";
import { QESRadioButton, QESRadioGroup } from "@app/shared/qes-standards";
import { FC, useContext, useMemo } from "react";
import { VolumeReportsContext } from "./VolumeReportsContext";
import { Roles, UserContext } from "@app/user";

export const VolumeReportsStatesFilters: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const wizardContext = useContext(VolumeReportsContext);
  const userContext = useContext(UserContext);
 
  const showFillableByMultiple = useMemo(() => {
    return (
      userContext.roles.includes(Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER)
    );
  }, [userContext.roles]);

  return (
    <section>
      <h2 className="header-m">State Filter</h2>
      <p>Please select the states to include:</p>

      <QESRadioGroup groupLabel="Include" groupContainerClass="mt-4">
        <QESRadioButton
          label="All States"
          name="states-gaps"
          testId="volume-reports__states-gaps-filters--all"
          value={ExportGapFilterType.All}
          checked={wizardContext.statesGapsFilter === ExportGapFilterType.All}
          onChange={(e) =>
            wizardContext.setStatesGapsFilter(
              e.target.value as ExportGapFilterType,
            )
          }
        />
        <QESRadioButton
          label="States with Gaps"
          name="states-gaps"
          testId="volume-reports__states-gaps-filters--gaps"
          value={ExportGapFilterType.Gaps}
          checked={wizardContext.statesGapsFilter === ExportGapFilterType.Gaps}
          onChange={(e) =>
            wizardContext.setStatesGapsFilter(
              e.target.value as ExportGapFilterType,
            )
          }
        />
        <QESRadioButton
          label="States with Gaps Fillable by Single Provider"
          name="states-gaps"
          testId="volume-reports__states-gaps-filters--fillable-by-single-provider"
          value={ExportGapFilterType.FillableBySingleProvider}
          checked={
            wizardContext.statesGapsFilter ===
            ExportGapFilterType.FillableBySingleProvider
          }
          onChange={(e) =>
            wizardContext.setStatesGapsFilter(
              e.target.value as ExportGapFilterType,
            )
          }
        />
        <QESRadioButton
          label="States with Exceptions"
          name="states-gaps"
          testId="volume-reports__states-gaps-filters--exceptions"
          value={ExportGapFilterType.Exceptions}
          checked={
            wizardContext.statesGapsFilter === ExportGapFilterType.Exceptions
          }
          onChange={(e) =>
            wizardContext.setStatesGapsFilter(
              e.target.value as ExportGapFilterType,
            )
          }
        />
        {showFillableByMultiple && (
          <QESRadioButton
            label="States with Fillable Gaps"
            name="states-gaps"
            testId="volume-reports__states-gaps-filters--fillable-gaps"
            value={ExportGapFilterType.FillableGaps}
            checked={
              wizardContext.statesGapsFilter ===
              ExportGapFilterType.FillableGaps
            }
            onChange={(e) =>
              wizardContext.setStatesGapsFilter(
                e.target.value as ExportGapFilterType,
              )
            }
          />
        )}
      </QESRadioGroup>
    </section>
  );
};
